export default {
  tourUi: {
    loading: 'Loading tour...',
    status: {
      unavailable: 'Unavailable',
    },
    backToTours: 'Back to tours',
    seo: {
      keywordPrefix: 'Paraty tour',
      breadcrumbHome: 'Home',
      breadcrumbTours: 'Tours',
      touristTypes: ['Family', 'Couple', 'Adventure'],
    },
    gallery: {
      expand: 'Enlarge image',
      close: 'Close',
      photoAlt: '{{title}} - photo {{n}}',
      thumbAlt: '{{title}} - thumbnail {{n}}',
    },
    booking: {
      pixDeposit: 'Deposit via Pix',
      remaining: 'Balance due on the day',
      depositNote: 'Deposit of {{rate}}% of the total, with a minimum of R$ 20,00.',
      depositFixedPerson: 'Deposit of {{amount}} per person.',
      depositFixedBooking: 'Fixed deposit of {{amount}} per booking.',
      depositMixed: 'The deposit adds up what each tour charges (percentage or fixed amount), with a minimum of R$ 20,00.',
      fullNote: 'The full price of the tour is paid now to secure the booking.',
      minDate: 'Please choose a date on or after {{date}}.',
      seatsLeft_one: 'Only {{count}} spot left for this tour.',
      seatsLeft_other: 'Only {{count}} spots left for this tour.',
      decrease: 'Decrease {{label}}',
      increase: 'Increase {{label}}',
    },
  },
};
